import {
  useGetListItems,
  useMutateItem,
  useMutateUpload,
} from "../../../hooks/entityMethodsHook";

export const useGetProjectImagesExifData = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/exif-data`;
  return useMutateUpload(queryKey, uri);
};

export const useUploadProjectImages = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/upload`;
  return useMutateUpload(queryKey, uri);
};

export const useGetProjectImages = (
  queryKey: string,
  projectId: string | undefined,
  params = {},
  enabled?: boolean
) => {
  const uri = `projects/${projectId}/photos`;
  return useGetListItems(queryKey, uri, params, enabled);
};
